import { MenuItem, VueRouter } from "@abaco/web-common/src/app";

export function createMenu(router: VueRouter): MenuItem[] {
    return [
        {
            id: "import-company-base",
            descrKey: "import-company",
            icon: "fa fa-download",
            onClick: () => router.push({ name: "import-company-base" }),
            get isVisible() {
                return true;
            }
        },
        {
            id: "uma-dealer-management",
            descrKey: "uma-dealer-management",
            icon: "fal fa-truck",
            onClick: () => router.push({ name: "uma-dealer-management" }),
            get isVisible() {
                return true;
            }
        },
        {
            id: "uma-delivery-management",
            descrKey: "uma-delivery-management",
            icon: "fal fa-truck-loading",
            onClick: () => router.push({ name: "uma-delivery-management" }),
            get isVisible() {
                return true;
            }
        },
        {
            id: "uma-withdrawal-insert",
            descrKey: "uma-withdrawal-insert",
            icon: "fas fa-calendar-plus",
            onClick: () => router.push({ name: "uma-withdrawal-insert" }),
            get isVisible() {
                return true;
            }
        },
        {
            id: "agromatrici-agleader-home",
            descrKey: "agromatrici-agleader-home",
            icon: "fas fa-sign-in",
            onClick: () => window.open("https://www.agfiniti.com/Account/Login", '_blank'),
            get isVisible() {
                return true;
            }
        },
        {
            id: "assets-profitosan",
            descrKey: "profitosan",
            icon: "fa fa-circle",
            onClick: () => router.push({ name: "profitosan" }),
            get isVisible() {
                return true;
            }
        },
        {
            id: "siti-reports-access",
            descrKey: "siti-reports-access",
            icon: "fa fa-files",
            onClick: () => router.push({ name: "siti-reports-access" }),
            get isVisible() {
                return true;
            }
        },
    ];
}

